import { PermissionConfig, PermissionKey } from './roles-dialog.types';

export const PERMISSIONS_CONFIG: readonly PermissionConfig[] = [
  {
    controlName: 'inventory',
    labelKey: 'shop-settings.roles.rolesModal.permissions.inventory',
    isAlt: true,
  },
  {
    controlName: 'customers',
    labelKey: 'shop-settings.roles.rolesModal.permissions.customers',
    isAlt: false,
  },
  {
    controlName: 'orders',
    labelKey: 'shop-settings.roles.rolesModal.permissions.orders',
    isAlt: true,
  },
  {
    controlName: 'admins',
    labelKey: 'shop-settings.roles.rolesModal.permissions.admins',
    isAlt: false,
  },
  {
    controlName: 'system',
    labelKey: 'shop-settings.roles.rolesModal.permissions.system',
    isAlt: true,
  },
];

export const PERMISSION_MAP: Record<PermissionKey, number> = {
  inventory: 1,
  customers: 2,
  orders: 3,
  admins: 4,
  system: 5,
};
